var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',_vm._b({staticClass:"grid-form-item"},'el-col',_vm.layout,false),[_c('y-form-item',_vm._b({},'y-form-item',_vm.formItemProps,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }